import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolder,
  faFolderOpen,
  faFile,
  faFolderClosed,
} from "@fortawesome/free-solid-svg-icons";
import ContextMenu from "./MyTreeContext";
import ConfirmModal from "./ConfirmModal";

const treeSource = "my-tree";

const renderTree = (
  nodes,
  expandedNodes,
  toggleNode,
  handleDrop,
  handleDragOver,
  handleDragStart,
  handleContextMenu,
  handleNodeClick,
  isMain = false
) => {
  return (
    // change paddingLeft from 20px to 14px
    <ul style={{ listStyleType: "none", paddingLeft: "14px" }}>
      {nodes.map((node, index) => (
        <li
          className={`${!isMain && "py-2"}`}
          key={node.id}
          onDrop={(e) => handleDrop(e, node.id)}
          onDragOver={(e) => handleDragOver(e, node.id)}
          draggable
          onDragStart={(e) => handleDragStart(e, node)}
          onContextMenu={(e) => handleContextMenu(e, node)}
        >
          {node.type === "folder" ? (
            <>
              <span
                onClick={() => toggleNode(node.id)}
                style={{ cursor: "pointer" }}
                title={node.id}
              >
                {/* Add padding to icon */}
                <FontAwesomeIcon
                  className="pr-2"
                  icon={
                    expandedNodes.includes(node.id)
                      ? faFolderOpen
                      : faFolderClosed
                  }
                />{" "}
                {node.label}
              </span>
              {expandedNodes.includes(node.id) &&
                node.children &&
                node.children.length > 0 &&
                renderTree(
                  node.children,
                  expandedNodes,
                  toggleNode,
                  handleDrop,
                  handleDragOver,
                  handleDragStart,
                  handleContextMenu,
                  handleNodeClick
                )}
            </>
          ) : (
            <span
              onClick={() => handleNodeClick(node)}
              style={{ cursor: "pointer" }}
              title={`[${node.instance_type}] ${node.label}`}
            >
              <FontAwesomeIcon icon={faFile} /> {node.label}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

const MyTreeView = ({
  nodes,
  handleDrop,
  onDeleteDashboard,
  handleAddNewFolderClick,
  handleDeleteFolder,
  setCurrentPage,
  setSelectedNodeId,
}) => {
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    node: null,
    type: null,
  });
  const [confirmModal, setConfirmModal] = useState({
    visible: false,
    node: null,
  });
  const contextMenuRef = useRef(null);

  useEffect(() => {
    // const handleClickOutside = (event) => {
    //   if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
    //     setContextMenu({ visible: false, x: 0, y: 0, node: null, type: null });
    //   }
    // };

    const handleClickOutside = (event) => {
      setContextMenu({ visible: false, x: 0, y: 0, node: null, type: null });
    };

    // document.addEventListener("mousedown", handleClickOutside);
    if (contextMenu.visible) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [contextMenu.visible]);

  const toggleNode = (nodeId) => {
    setExpandedNodes((prevExpandedNodes) =>
      prevExpandedNodes.includes(nodeId)
        ? prevExpandedNodes.filter((id) => id !== nodeId)
        : [...prevExpandedNodes, nodeId]
    );
  };

  const handleDragStart = (e, node) => {
    if (node.type === "dashboard") {
      e.dataTransfer.setData(
        "application/json",
        JSON.stringify({ ...node, treeSource, folderId: node.parent_id })
      );
    }
  };

  const handleDragOver = (e, nodeId) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleContextMenu = (e, node) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      node,
      type: node.type,
    });
  };

  const handleNodeClick = (node) => {
    if (node.type === "dashboard") {
      setSelectedNodeId(node.id);
      setCurrentPage("dashboard");
    }
  };

  const handleDeleteDashboard = () => {
    setConfirmModal({ visible: true, node: contextMenu.node });
    setContextMenu({ visible: false, x: 0, y: 0, node: null, type: null });
  };

  const confirmDeleteDashboard = () => {
    onDeleteDashboard(confirmModal.node);
    setConfirmModal({ visible: false, node: null });
  };

  const cancelDeleteDashboard = () => {
    setConfirmModal({ visible: false, node: null });
  };

  const isMain = true;
  return (
    <div>
      {/* remove setSelectedNodeId from function invoke cause it's not use in function */}
      {renderTree(
        nodes,
        expandedNodes,
        toggleNode,
        handleDrop,
        handleDragOver,
        handleDragStart,
        handleContextMenu,
        handleNodeClick,
        isMain
      )}
      {contextMenu.visible && (
        // <div ref={contextMenuRef}>
          <ContextMenu
            x={contextMenu.x}
            y={contextMenu.y}
            onDeleteDashboard={handleDeleteDashboard}
            nodeType={contextMenu.type}
            nodeId={contextMenu.node.id}
            handleAddNewFolderClick={handleAddNewFolderClick}
            handleDeleteFolder={handleDeleteFolder}
            contextMenu={contextMenu}
          />
      )}
      {confirmModal.visible && (
        <ConfirmModal
          message="Are you sure you want to delete this dashboard?"
          onConfirm={confirmDeleteDashboard}
          onCancel={cancelDeleteDashboard}
        />
      )}
    </div>
  );
};

export default MyTreeView;
